module.exports = __webpack_public_path__ + "7dcbbedd9105a6fc3c357291d9f91dfe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-s.png
// module id = 2054
// module chunks = 0